import { dateFormatPipe } from "./datePipe.pipe";
import { ObjectKeyPipe } from './object-key.pipe'
import { SortPipe } from "./sort.pipe";
import { FilterPipe } from "./filter.pipe";

export const pipes = [
    dateFormatPipe,
    ObjectKeyPipe,
    SortPipe,
    FilterPipe
];


// WEBPACK FOOTER //
// ./src/app/shared/_pipes/index.ts